export default [
    {cod:1,id:"vaca",nombre:"Vaca",sexo:"H"},
    {cod:2,id:"vaquillona",nombre:"Vaquillona",sexo:"H"},
    {cod:3,id:"ternero",nombre:"Ternero",sexo:"M"},
    {cod:4,id:"ternera",nombre:"Ternera",sexo:"H"},
    {cod:5,id:"novillo",nombre:"Novillo",sexo:"M"},
    {cod:6,id:"novillito",nombre:"Novillito",sexo:"M"},
    {cod:7,id:"torito",nombre:"Torito",sexo:"M"},
    {cod:8,id:"toro",nombre:"Toro",sexo:"M"}
    
]